import { serviceRequest } from 'utils/http';
import { TranslationService } from 'common/api';

export function getTranslationsAPI() {
  return serviceRequest(() =>
    TranslationService.translationControllerGetTranslations()
  );
}
